import React from "react";
import { StyledButton } from "./styles";

interface CButtonProps {
  title?: string;
  icon?: React.ReactNode;
  onClick?: (event) => void;
  style?: React.CSSProperties;
  border?: { style?: string; width: string; color?: string };
  backgroundHover?: string;
  textHover?: string;
  iconLeft?: boolean;
  size?: number;
  textStyle?: React.CSSProperties;
  lefticon?: React.ReactNode;
  id?: string;
}

const CButton: React.FC<CButtonProps> = ({
  title,
  icon,
  onClick,
  style,
  border,
  backgroundHover,
  textHover,
  iconLeft,
  size,
  textStyle,
  lefticon,
  id,
}) => {

  const handleClick = (e) => {
    // e.stopPropagation();
    // alert("CButton clicked"); // 디버깅
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <StyledButton
      size={size}
      id={id}
      className={"customBtn"}
      type="button"
      backgroundHover={backgroundHover}
      textHover={textHover}
      style={{
        all: "unset",
        pointerEvents: "auto", // 클릭 이벤트 허용
        zIndex: 10, // 다른 요소 위로 렌더링
        borderStyle: border?.style ?? "solid",
        borderWidth: border?.width ?? 0,
        borderColor: border?.color ?? "transparent",
        borderRadius: 10,
        display: "flex",
        flexDirection: icon ? "row" : "column",
        alignItems: "center",
        alignSelf: "center",
        justifyContent: "center",
        ...style,
      }}
      onClick={handleClick}
    >
      {iconLeft && icon ? icon : null}
      {lefticon ? lefticon : null}
      {title}
      {!iconLeft && icon ? icon : null}
    </StyledButton>
  );
};

export default React.memo(CButton);
